import React from 'react';
import { Link } from 'react-router-dom';
import './AccountDeletion.css';

function AccountDeletion() {
  return (
    <div className="account-deletion">
      <div className="container">
        <h1>Account Deletion Request</h1>

        <div className="deletion-content">
          <div className="warning-box">
            <h2>⚠️ Important Information</h2>
            <p>Deleting your account is permanent and cannot be undone. This action will:</p>
            <ul>
              <li>Permanently delete all your account data</li>
              <li>Remove access to all At Home Laundromat services</li>
              <li>Delete your transaction history</li>
              <li>Cancel any active subscriptions or services</li>
            </ul>
          </div>

          <div className="deletion-methods">
            <h2>How to Delete Your Account</h2>

            <div className="method-card">
              <h3>Method 1: In-App Request</h3>
              <p>To delete your account through the app:</p>

              <div className="info-box">
                <h4>Steps to Follow:</h4>
                <ol>
                  <li>Open the At Home Laundromat mobile app</li>
                  <li>Go to your Profile Settings</li>
                  <li>Scroll down to "Account Management"</li>
                  <li>Tap "Request Account Deletion"</li>
                  <li>Confirm your email address</li>
                  <li>Review the warning and confirm deletion</li>
                  <li>Submit your request</li>
                </ol>
                <p className="verification-note">
                  <strong>Note:</strong> You will receive a verification email to confirm your identity before the account is deleted. This typically takes 24-48 hours to process.
                </p>
              </div>
            </div>

            <div className="method-card">
              <h3>Method 2: Email Request</h3>
              <p>You can also request account deletion by contacting our support team:</p>

              <div className="contact-info">
                <p><strong>Email:</strong> <a href="mailto:support@trantechus.com">support@trantechus.com</a></p>
                <p><strong>Phone:</strong> <a href="tel:+16503360577">(650) 336-0577</a></p>
              </div>

              <div className="info-box">
                <h4>What to Include in Your Email:</h4>
                <ul>
                  <li>Subject line: "Account Deletion Request"</li>
                  <li>Your registered email address</li>
                  <li>Account username or ID (if known)</li>
                  <li>Brief reason for deletion (optional)</li>
                </ul>
                <p className="verification-note">
                  <strong>Note:</strong> We will verify your account ownership before processing the deletion request. This typically takes 1-2 business days.
                </p>
              </div>
            </div>
          </div>

          <div className="back-link">
            <Link to="/">← Back to Home</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccountDeletion;
